import { get } from 'lodash'
import router from '@/router'
import store from '@/store'
import { PATH_NAME_SEARCH_TAG_GROUP } from '@/common/router.const'

export const clickTag = ({ currentSection, tag, contentInfo }) => {
  console.log(tag)
  let tagList = []
  if (currentSection === 'clip') {
    get(contentInfo, ['tags', 'list'], []).map((tag) => {
      if (typeof tag === 'string') {
        tagList.push({
          text: tag,
          value: tag,
          taggroup: 'tag'
        })
      }
    })
  } else {
    router.replace({
      name: PATH_NAME_SEARCH_TAG_GROUP,
      query: {
        tagCode: get(tag, 'value', ''),
        tagText: get(tag, 'text', ''),
        listType: currentSection,
        contentId: get(contentInfo, [currentSection === 'vod' ? 'contentid' : 'movieid'], ''),
        bt: 'n'
      }
    })
  }
  // const targetIndex = findIndex(tagList, (t) => {
  //   return t.value === tag.value
  // })
  // const clickedTag = tagList.splice(targetIndex, 1)
  // tagList.unshift(clickedTag[0])
  // router.replace('/search?bt=n')
}
export const searchByKeyword = ({ keyword }) => {
  store.commit('deleteAllTag')
  setTimeout(() => {
    router.push(`/search?searchWord=${keyword}&searchCategory=all&bt=n`)
  }, 200)
}

/**
 * contentInfo 를 받아 qualities 에 있는 media type 중 가장 높은 우선순위를 출력한다.
 * @param contentInfo
 * @returns {string}
 */
export const getVideoSpec = (contentInfo) => {
  const priorityList = ['DV', 'HDR10', 'SDR'] // video quality 우선순위 오름차순 정렬 배열
  const mediatypes = get(contentInfo, 'qualities.mediatypes', [])
  const [ priorityQuality ] = mediatypes.map(item => `${priorityList.indexOf(item)}_${item}`).sort().map(v => v.replace(/(\d+)_/gi, ''))

  switch (priorityQuality) {
    case 'DV' :
      return 'dolby-vision'

    case 'HDR10' :
      return 'HDR10'

    default :
      return ''
  }
}

/**
 * playtime, viewtime 를 받아 playtime 과 view time 을 뺀 값을 리턴한다. (최소값은 1, 최대값은 999)
 * @param playtime
 * @param viewtime
 * @returns {number}
 */
export const getRemainViewTime = (playtime, viewtime) => {
  const max = 999
  const min = 1
  const remainTime = Math.round((Number(playtime - viewtime)) / 60)

  if (remainTime <= min) return min
  if (remainTime >= max) return max
  return remainTime
}

/**
 * text 를 받아 html 텍스트를 랜더링한다. (v-clamp 에서 사용)
 * @param text
 * @returns {Exclude<GetFieldType<HTMLSpanElement, "textContent">, null | undefined> | string}
 */
export const getDecodedHTMLText = (text) => {
  const element = document.createElement('span')
  element.innerHTML = text
  return get(element, 'textContent', '')
}
